module.exports = __webpack_public_path__ + "img/logo_mop-small.f4a89fc6.svg";